module.exports = __webpack_public_path__ + "img/brackets_big_left.a38424ae.svg";